/* eslint-disable */
import {
  AccordionActions,
  createStyles,
  Divider,
  Theme,
  withStyles,
} from "@material-ui/core";
import { Heading } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Button as ButtonMat } from "@material-ui/core";
import {
  checkPartyImport,
  partyImport,
} from "../../../utils/store/actions/users.actions";
import { DropzoneArea } from "material-ui-dropzone";
import { B4FRadio } from "../B4FFields/B4FRadio";
import { B4FSelect } from "../B4FFields/B4FSelect";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    dropzone: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    previewChip: {
      maxWidth: "300px",
      color: "#ae0064",
    },
  });
class PartyImports extends React.Component<any, any> {
  static TARGETS = {
    ASSET: "ASSET",
    CLIENT: "CLIENT",
    RELATION: "RELATION",
    DISTRIBUTOR: "DISTRIBUTOR",
    SERVICE_PROVIDER: "SERVICE_PROVIDER",
  };

  static targetOptions = [
    { key: "ASSET", label: "ASSET" },
    { key: "CLIENT", label: "CLIENT" },
    { key: "RELATION", label: "RELATION" },
    { key: "DISTRIBUTOR", label: "DISTRIBUTOR" },
    { key: "SERVICE_PROVIDER", label: "SERVICE_PROVIDER" },
  ];

  static radioButtonOptions = [
    { label: "YES_NO.YES", key: true },
    { label: "YES_NO.NO", key: false },
  ];

  constructor(props: any) {
    super(props);
    this.state = { selectedParty: null };
  }

  setIsAnonimized = (e: HTMLInputElement) => {
    this.setState({ isAnonimized: e.value === "true" ? true : false });
  };

  afterPartyHasBeenSelected = (event: any) => {
    this.resetState();
    this.setState({ selectedParty: event.value });
  };

  partyFileHandler = (partyList: any) => {
    this.setState({ partyList: partyList });

    if (!!this.state.partyList) this.setState({ partyCheck: null });

    partyList.map((template: any) => {
      const file: FormData = new FormData();
      file.append("file", template);
      this.setState({ partyListValidated: file });
    });
  };

  resetState = () =>
    this.setState({
      partyCheck: undefined,
      isAnonimized: undefined,
      partyList: undefined,
      selectedParty: "",
      loading: undefined,
    });

  checkCsvFile = async () => {
    try {
      this.setState({ loading: true });
      await this.props.checkPartyImport(
        this.state.selectedParty,
        this.state.partyListValidated
      );
      const userProp = this.state.selectedParty.toLowerCase();
      this.setState({
        partyCheck: this.props.Users[`check_${userProp}s_import`],
        loading: false,
      });
    } catch (err) {
      console.error("Error while checking the csv file ", err);
    }
  };

  uploadCsvFile = async () => {
    this.setState({ loading: true });
    try {
      await this.props.partyImport(
        this.state.selectedParty,
        this.state.partyListValidated,
        this.state.isAnonimized
      );
      this.resetState();
    } catch (err) {
      console.error(err);
    }
  };

  render() {
    const { classes, t } = this.props;
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="modules"
        >
          <Typography className={classes.heading}>
            {" "}
            {t("PARTY_IMPORTS")}{" "}
          </Typography>
        </AccordionSummary>

        <AccordionDetails style={{ display: "flex", flexDirection: "column" }}>
          <Heading
            fontSize="16px"
            color="#ae0064"
            fontWeight="normal"
            ontFamily="ABeeZee"
            mt={2}
            mb={2}
          >
            {/* Import selected */}
            <B4FSelect
              label={t("SELECTED")}
              key="selectedImport"
              id="selectedImport"
              isRequired={true}
              visible={true}
              onChange={this.afterPartyHasBeenSelected}
              onBlur={() => {}}
              value={this.state.selectedParty}
              options={PartyImports.targetOptions}
            />
            {!!this.state.selectedParty && this.state.partyCheck?.length === 0 && (
              <div className={classes.root} style={{ fontSize: "10px" }}>
                <B4FRadio
                  label={t("IS_ANONYMIZED")}
                  key="isAnonimized"
                  id="isAnonimized"
                  isRequired={true}
                  visible={true}
                  onChange={this.setIsAnonimized}
                  options={PartyImports.radioButtonOptions}
                  value={this.state.isAnonimized}
                />
              </div>
            )}

            <List className={classes.root}>
              {/* loading  */}
              {this.state.selectedParty && this.state.loading === true && (
                <div>{t("LOADING") + "..."}</div>
              )}
              {/* error message  */}
              {this.state.selectedParty &&
                !!this.state.partyCheck &&
                !!this.state.partyList?.length &&
                !this.state.loading &&
                this.state.partyCheck?.map((property: any) => (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {property}
                  </div>
                ))}
              {/* success message  */}
              {this.state.selectedParty &&
                this.state.partyCheck?.length === 0 &&
                !this.state.loading &&
                !!this.state.partyList && <div>{t("SUCCESS")}</div>}
            </List>
          </Heading>
        </AccordionDetails>
        <AccordionDetails style={{ display: "flex", flexDirection: "column" }}>
          {!!this.state.selectedParty && (
            <DropzoneArea
              dropzoneClass={classes.dropzone}
              showFileNames
              showPreviews={true}
              showPreviewsInDropzone={false}
              useChipsForPreview
              acceptedFiles={[".csv"]}
              previewGridProps={{
                container: { spacing: 1, direction: "column" },
              }}
              previewChipProps={{ classes: { root: classes.previewChip } }}
              previewText={t("FILE")}
              dropzoneText={t("UPLOAD")}
              filesLimit={1}
              maxFileSize={100000000}
              onChange={this.partyFileHandler}
              onDelete={this.resetState}
            />
          )}
        </AccordionDetails>
        <Divider />
        <AccordionActions>
          {!!this.state.selectedParty && !!this.state.partyList?.length && (
            <ButtonMat
              onClick={this.checkCsvFile}
              size="small"
              style={{ color: "#ae0064" }}
            >
              {t("TEST")}
            </ButtonMat>
          )}
          {!!this.state.selectedParty &&
            this.state.isAnonimized !== undefined &&
            !!this.state.partyList?.length && (
              <ButtonMat
                onClick={this.uploadCsvFile}
                size="small"
                style={{ color: "#ae0064" }}
              >
                {t("SAVE")}
              </ButtonMat>
            )}
        </AccordionActions>
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  partyImport,
  checkPartyImport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PartyImports)));
